export default __webpack_public_path__ + "static/media/sprinkle.51804d5d.svg";